"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniswapExtraProcessor = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _util = require("./util");
var _ethTypes = require("@blockwell/eth-types");
var _bignumber = _interopRequireDefault(require("bignumber.js"));
class UniswapExtraProcessor {
  constructor() {
    (0, _defineProperty2.default)(this, "key", "uniswap");
  }
  async process(parameters, submission) {
    let swaps = [];
    for (let {
      event,
      step
    } of (0, _util.findEvents)(submission, "Swap")) {
      let amount0In = (0, _ethTypes.ethResolveStringParameter)(event.params, "amount0In");
      if (amount0In) {
        let transfers = step.events.filter(it => it.event === "Transfer");
        let fromAddress = transfers[0].address;
        let toAddress = transfers[transfers.length - 1].address;
        let from = await (0, _util.getTokenData)(parameters.contracts, step.network, fromAddress);
        let to = await (0, _util.getTokenData)(parameters.contracts, step.network, toAddress);
        let val = new _bignumber.default((0, _ethTypes.ethResolveStringParameter)(event.params, "amount0Out"));
        let feeStep = submission.data.steps[2];
        if (feeStep) {
          let ev = feeStep.events.find(it => it.event === "Transfer");
          val = val.minus((0, _ethTypes.ethResolveStringParameter)(ev.params, "2"));
        }
        swaps.push({
          from,
          to,
          fromAmount: new _bignumber.default(submission.data.getInput("amount")).toFormat(),
          toAmount: val.div(`1e${to.decimals}`).toFormat()
        });
      }
    }
    return swaps;
  }
}
exports.UniswapExtraProcessor = UniswapExtraProcessor;
//# sourceMappingURL=UniswapExtra.js.map